import { TextField } from '@mui/material';
import React, { useContext } from 'react';
import { EditorContext } from '../../../utils/contexts';

export default function FacebookPage() {
  const { settings, updateSettings } = useContext(EditorContext);

  const updateURL = (event) => {
    const customSettings = {
      ...settings.settings,
      url_to_like: event.target.value,
    };
    updateSettings({ settings: customSettings });
  };

  return (
    <>
      <TextField
        fullWidth
        size='small'
        variant='outlined'
        label='Facebook Page URL'
        value={settings.settings.url_to_like}
        onChange={updateURL}
        placeholder='https://www.facebook.com/hellobar'
      />
    </>
  );
}
